import type { ISODate, UUID } from '@/features/shared/data/string.types.ts'

export enum MediaFileCategory {
  Voice = 'voice',
  SoundEffect = 'sound effect',
  Music = 'music',
  Media = 'media',
  Advert = 'advert',
}

export const AcceptedMediaFileExtensions = ['.ogg', '.wav', '.mp3', '.flac']

export interface MediaFile {
  createdAt: ISODate
  createdBy: UUID
  updatedAt: ISODate
  duration: number
  category: {
    id?: UUID | undefined
    name?: MediaFileCategory | undefined
  }
  id: UUID
  name: string
  type: {
    id?: UUID | undefined
    name?: string | undefined
  }
  size: number // todo: B? KB? MB?
  status: string // todo: to be defined
  url: string
}

export interface MediaSource {
  id: UUID
  kind: 'media'
  mediaFile: MediaFile
  file?: undefined
}

export interface UploadSource {
  id: UUID
  kind: 'upload'
  mediaFile?: MediaFile
  file: File
}

export interface RecordingSource {
  id: UUID
  kind: 'recording'
  mediaFile?: MediaFile
  file: File
}

export type AudioFileSource = MediaSource | UploadSource | RecordingSource
